import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useEffect,
} from "react";
import { Link } from "react-router-dom";
import { Offcanvas } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { updateCandidates } from "../../../store/actions/Candidates/candidateActions";
import { industrySector } from "../../constant/industrySector";

const CandidateClassification = forwardRef((props, ref) => {
  const dispatch = useDispatch();

  // Initialize form data with props (existing candidate details)
  const [formData, setFormData] = useState({
      industrySector: props.candidate?.industrySector || "",
      jobTitles: props.candidate?.jobTitles || "",
      skills: props.candidate?.skills || "",
      qualifications: props.candidate?.qualifications || "",
      marketing: props.candidate?.marketing || "",
  });

  useEffect(() => {
    setFormData({
      industrySector: props.candidate?.industrySector || "",
      jobTitles: props.candidate?.jobTitles || "",
      skills: props.candidate?.skills || "",
      qualifications: props.candidate?.qualifications || "",
      marketing: props.candidate?.marketing || "",
    });
  }, [props.candidate]);

  const [errors, setErrors] = useState({});
  const [editEmploye, setEditEmploye] = useState(false);

  useImperativeHandle(ref, () => ({
    showEmployeModal() {
      setEditEmploye(true);
    },
  }));

  const validate = () => {
    const newErrors = {};
    if (!formData.industrySector) {
      newErrors.industrySector = "Please select industry sector.";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
    setErrors({ ...errors, [field]: "" });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      const payload = {
        industrySector: formData?.industrySector,
        jobTitles: formData?.jobTitles,
        skills: formData?.skills,
        qualifications: formData?.qualifications,
        marketing: formData?.marketing,
      };
      dispatch(
        updateCandidates(
          payload,
          setEditEmploye,
          props.candidate?._id,
          props.token
        )
      );
    }
  };

  return (
    <Offcanvas
      show={editEmploye}
      onHide={() => setEditEmploye(false)}
      className="offcanvas-end customeoff"
      placement="end"
    >
      <div className="offcanvas-header">
        <h5 className="modal-title">{props.Title || "Edit Candidate"}</h5>
        <button
          type="button"
          className="btn-close"
          onClick={() => setEditEmploye(false)}
        >
          <i className="fa-solid fa-xmark"></i>
        </button>
      </div>
      <div className="offcanvas-body">
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-xl-6 mb-3">
              <label className="form-label">
                Industry Sector <span className="text-danger">*</span>
              </label>
              <select
                className="form-control form-select"
                value={formData.industrySector}
                onChange={(e) =>
                  handleInputChange("industrySector", e.target.value)
                }
              >
                <option value=""></option>
                {industrySector?.map((itm) => (
                  <option value={itm}>{itm}</option>
                ))}
              </select>
              {errors.industrySector && (
                <small className="text-danger">{errors.industrySector}</small>
              )}
            </div>


            <div className="col-xl-6 mb-3">
              <label className="form-label">
                Job Titles
              </label>
              <select
                className="form-control form-select"
                value={formData.jobTitles}
                onChange={(e) =>
                  handleInputChange("jobTitles", e.target.value)
                }
              >
                <option value=""></option>
              </select>
            </div>

            <div className="col-xl-6 mb-3">
              <label className="form-label">
                Skills
              </label>
              <select
                className="form-control form-select"
                value={formData.skills}
                onChange={(e) =>
                  handleInputChange("skills", e.target.value)
                }
              >
                <option value=""></option>
              </select>
            </div>

            <div className="col-xl-6 mb-3">
              <label className="form-label">
                Qualification
              </label>
              <select
                className="form-control form-select"
                value={formData.qualifications}
                onChange={(e) =>
                  handleInputChange("qualifications", e.target.value)
                }
              >
                <option value=""></option>
                <option value="act_e_learning">Act E Learning</option>
                <option value="coshh">COSHH</option>
                <option value="goods_in_out">Goods In/Out</option>
                <option value="ids_checked">IDS Checked</option>
                <option value="lfc_ind_office">LFC Ind Office</option>
                <option value="lfc_ind_site">LFC Ind Site</option>
              </select>
            </div>

            <div className="col-xl-6 mb-3">
              <label className="form-label">
                Marketing
              </label>
              <select
                className="form-control form-select"
                value={formData.marketing}
                onChange={(e) =>
                  handleInputChange("marketing", e.target.value)
                }
              >
                <option value=""></option>
                <option value="Opt-in">Opt-in</option>
                <option value="Opt-out">Opt-out</option>
                </select>
            </div>
           
          </div>
          <div>
            <button type="submit" className="btn btn-primary me-1">
              Update
            </button>
            <Link
              to={"#"}
              onClick={() => setEditEmploye(false)}
              className="btn btn-danger light ms-1"
            >
              Cancel
            </Link>
          </div>
        </form>
      </div>
    </Offcanvas>
  );
});

export default CandidateClassification;
